/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";

import {
  ILoadingMethods,
  LoadingService,
  IStaticPageContentMethods,
  StaticPageContentService,
  IBoxDetailMethods,
  BoxDetailService,
  IUpdateBoxMethods,
  UpdateBoxService,
} from "./components";

export type BoxDetailPageAgent = IStaticPageContentMethods &
  ILoadingMethods &
  IBoxDetailMethods &
  IUpdateBoxMethods;

const getPlugins = () => {
  return [
    new LoadingService(),
    new StaticPageContentService(),
    new BoxDetailService(),
    new UpdateBoxService(),
  ];
};

export const getAgent = () => {
  return createAgent<BoxDetailPageAgent>({
    plugins: getPlugins(),
  });
};
